// @ts-nocheck
import { InviteYourColleagueModel } from "@store/Framework/Types/ApiModels";
import {
    InviteYourColleagueApiParameter,
    submitInviteYourColleagueEmail,
} from "@store/Framework/Services/InviteYourColleagueService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type SubmitSubmitInviteYourColleagueParameter = {
    inviteYourColleagueModel: InviteYourColleagueModel;
    onSuccess?: () => void;
    onError?: () => void;
} & HasOnSuccess &
    HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<
    SubmitSubmitInviteYourColleagueParameter,
    InviteYourColleagueApiParameter
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    await submitInviteYourColleagueEmail(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitInviteYourColleagueForm = createHandlerChainRunner(chain, "SubmitInviteYourColleagueForm");
export default submitInviteYourColleagueForm;
